module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.031547c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/singapore/font/notokr-regular.woff
// module id = 1mu9
// module chunks = 0